import { useTranslation } from 'react-i18next';
import { EngagementCampaignPostStatusForInsightCheck } from '@anytag/graphql';
import { Badge, BadgeProps } from '@anyui/core';

export interface PostInsightStatusProps {
  status?: EngagementCampaignPostStatusForInsightCheck;
  className?: string;
}

export const PostInsightStatus = ({ status, className }: PostInsightStatusProps) => {
  const { t } = useTranslation();

  const statusProps = ((): BadgeProps => {
    switch (status) {
      case EngagementCampaignPostStatusForInsightCheck.CONFIRMED:
        return { children: t('Option.Confirmed'), color: 'blue' };
      case EngagementCampaignPostStatusForInsightCheck.UNCONFIRMED:
        return { children: t('Option.Unconfirmed'), color: 'yellow' };
      default:
        return { children: null, color: 'zinc' };
    }
  })();

  return <Badge {...statusProps} className={className} />;
};
